import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { consumeOfficeResume } from "../../utils/officeMicrosoftLogin";

/** Wird entweder in der AppShell oder auf der eigenständigen Office-Route genutzt. */
export function useOfficeResume() {
  const { user, session } = useAuth();
  const [result, setResult] = useState<ReturnType<typeof consumeOfficeResume>>(null);
  useEffect(() => {
    if (!user?.id) return;
    const failed = new URL(window.location.href).searchParams.get("office_auth_error") === "1";
    const resumed = consumeOfficeResume(user.id, session?.activeOrganizationId || "default", failed);
    if (resumed) setResult(resumed);
  }, [user?.id, session?.activeOrganizationId]);
  return result;
}
